import { render, staticRenderFns } from "./SetorField.vue?vue&type=template&id=935951b2&scoped=true&"
import script from "./SetorField.vue?vue&type=script&lang=js&"
export * from "./SetorField.vue?vue&type=script&lang=js&"
import style0 from "./SetorField.vue?vue&type=style&index=0&id=935951b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935951b2",
  null
  
)

export default component.exports